var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoLocalization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-localization",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 28,
    height: 28,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M15.417,2A13.417,13.417,0,1,0,28.833,15.417,13.417,13.417,0,0,0,15.417,2ZM11.427,5.079A13.653,13.653,0,0,0,10.2,7.849L9.862,8.873l1.821.2L11.9,8.4A7.662,7.662,0,0,1,14.4,4.382c.337-.031.677-.049,1.021-.049s.685.018,1.021.049A7.664,7.664,0,0,1,18.929,8.4l.221.676,1.821-.2L20.637,7.85a13.656,13.656,0,0,0-1.231-2.771A11.146,11.146,0,0,1,25.075,9.99a47.122,47.122,0,0,1-9.571.918,49.5,49.5,0,0,1-9.743-.922A11.142,11.142,0,0,1,11.427,5.079ZM5.005,11.614a40.85,40.85,0,0,0,4.257.694,28.107,28.107,0,0,0-.171,3.109c0,.175,0,1.556.008,1.79l1.749-.041c0-.194-.007-1.462-.007-1.749A26.316,26.316,0,0,1,11,12.477c1.336.108,2.846.18,4.5.18,1.592,0,3.042-.067,4.327-.169a26.322,26.322,0,0,1,.162,2.928c0,.286,0,1.554-.007,1.75l1.749.039c.005-.235.008-1.614.008-1.789a28.094,28.094,0,0,0-.169-3.1,38.3,38.3,0,0,0,4.256-.7,11.066,11.066,0,0,1,.078,7.369,80.922,80.922,0,0,0-10.441-.531,83.535,83.535,0,0,0-10.54.531,11.066,11.066,0,0,1,.079-7.371Zm11.53,14.829a11.138,11.138,0,0,1-2.237,0c-1.26-.885-2.4-3.186-3-6.169,1.218-.043,2.607-.071,4.166-.071,1.523,0,2.878.026,4.068.067C18.937,23.256,17.8,25.558,16.535,26.444ZM5.655,20.66c.738-.084,2.033-.21,3.878-.308a16.4,16.4,0,0,0,1.9,5.4A11.146,11.146,0,0,1,5.655,20.66Zm13.744,5.1a16.406,16.406,0,0,0,1.9-5.409c1.854.1,3.146.225,3.878.31A11.146,11.146,0,0,1,19.4,25.757Z",
    transform: "translate(-1.417 -1.417)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLocalization);
export default __webpack_public_path__ + "static/media/ico-localization.51a0a9c0ed22e61967b6b7ec902f9863.svg";
export { ForwardRef as ReactComponent };